var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pb-5" },
    [
      _c("v-card-title", { staticClass: "title justify-center" }, [
        _vm._v("\n    The credentials you provided are not valid.\n  ")
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c("v-img", {
                staticClass: "mx-auto",
                attrs: {
                  src: "/static/errorImage.png",
                  "aspect-ratio": "1",
                  "max-width": "300",
                  "max-height": "300"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-440a1451", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440a1451","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Error401.vue
// module id = null
// module chunks = 